import { getFeatureVisitedCount } from './feature-visited.ts';

export const hasSeenAnyNudgeExceptMsr = () => {
	if (hasSeenJpdNudge()) {
		return true;
	}
	if (hasSeenJiraNudge()) {
		return true;
	}
	if (hasSeenLoomNudge()) {
		return true;
	}
	return false;
};

export const hasSeenJpdNudge = () => {
	if (getFeatureVisitedCount('crossJoinNudgesConfluenceToJpd') > 0) {
		return true;
	}
	return false;
};

export const hasSeenJiraNudge = () => {
	if (getFeatureVisitedCount('crossJoinNudgesV3') > 0) {
		return true;
	}
	return false;
};

export const hasSeenLoomNudge = () => {
	if (getFeatureVisitedCount('crossJoinNudgesConfluenceToLoom') > 0) {
		return true;
	}
	return false;
};
